import { CAPABILITY_META } from '../constants/capabilityMeta'
import { ModelDetailSection } from './ModelDetailSection'
import type { ModelCapability } from '../../../../../shared-pricing-config'
import { TagChip } from '@/features/models/components/ModelCardCells'

interface ModelDetailCapabilitiesProps {
  capabilities: Array<ModelCapability>
}

export function ModelDetailCapabilities({ capabilities }: ModelDetailCapabilitiesProps) {
  if (capabilities.length === 0) return null

  return (
    <ModelDetailSection title="Capabilities" note={`${capabilities.length} listed`}>
      <ul className="flex flex-wrap gap-1.5">
        {capabilities.map((cap) => {
          const m = CAPABILITY_META[cap]
          const Icon = m?.icon
          return (
            <li key={cap}>
              <TagChip icon={Icon}>{m?.label ?? cap}</TagChip>
            </li>
          )
        })}
      </ul>
    </ModelDetailSection>
  )
}
